<div *ngIf="!loading; else innerLoading" id="conversation-wrapper">
  <div id="header-wrapper">
    <div id="left-wrapper">
      <msd-avatar id="user-avatar-image" [text]="conversation?.patient?.initials"
        [src]="conversation?.patient?.profilePicture">
      </msd-avatar>
      <span id="user-name-text">{{conversation?.patient?.fullName}}</span>
    </div>
    <div *ngIf="displayMarkAsReadButton" id="right-wrapper">
      <button id="close-conversation-button" type="button" class="btn btn-link" (click)="onCloseConversation()">
        <ng-container *ngIf="closingConversation; else closeConversationButton">
          <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
          <span class="visually-hidden">Chargement...</span>
        </ng-container>
        <ng-template #closeConversationButton>
          Marquer comme lu
        </ng-template>
      </button>
    </div>
    <div id="right-wrapper-mobile">
      <button *ngIf="origin === 'message'" id="message-back" type="button" class="btn btn-primary btn-gradient" (click)="messageBack.emit()" [disabled]="!isBack">
        <i i-bs name="arrow-left-short" width="18" height="18"></i>
      </button>
      <button *ngIf="origin === 'message'" id="message-forward" type="button" class="btn btn-primary btn-gradient" (click)="messageForward.emit()" [disabled]="!isForward">
        <i i-bs name="arrow-right-short" width="18" height="18"></i>
      </button>
      <button *ngIf="origin === 'message'" id="message-close" type="button" class="btn btn-primary btn-gradient" (click)="messageClose.emit()">
        <i i-bs name="x" width="18" height="18"></i>
      </button>
      <button *ngIf="origin === 'list'" id="message-back" type="button" class="btn btn-primary btn-gradient" (click)="messageList.emit()">
        <i i-bs name="arrow-90deg-up" width="18" height="18"></i>
      </button>
    </div>
  </div>
  <div id="message-list-wrapper" [class.no-height-constraint]="origin === 'list'">
    <div *ngIf="messages && messages.length > 0; else emptyMessages" id="messages-list" #messagesList (scroll)="onMessagesScroll()">
      <ng-container *ngFor="let dayMessage of dayMessages | keyvalue">
        <msd-history-separator [date]="convertDate(dayMessage.key)"></msd-history-separator>
        <msd-message-content-cell *ngFor="let message of dayMessage.value" [avatarUrl]="message.avatarUrl"
          [date]="message.date" [message]="message.message" [name]="message.name" [audioUrl]="message.audioUrl"
          [initials]="message.initials" [imageUrl]="message.imageUrl">
        </msd-message-content-cell>
      </ng-container>
    </div>
    <ng-template #emptyMessages>
      <div style="margin: auto">
        Aucun message...
      </div>
    </ng-template>

    <div id="interaction-wrapper">
      <ng-container>
        <msd-image-preview-cell id="image-preview" *ngIf="imageUrl" [src]="imageUrl" (remove)="removeImage()"
          [canBeRemoved]="!sending"></msd-image-preview-cell>
        <msd-audio-preview-cell id="audio-preview" *ngIf="audioUrl" [url]="audioUrl" (remove)="removeAudio()"
          [canBeRemoved]="!sending"></msd-audio-preview-cell>
        <textarea *ngIf="!isAttachment"
                  [ngModel]="messageContent"
                  (ngModelChange)="onInput($event)"
                  aria-describedby="content"
                  class="form-control"
                  id="message-textarea"
                  placeholder="Votre message..."
                  type="text">
        </textarea>
      </ng-container>
      <div id="buttons-wrapper">
        <div id="attachment-wrapper">
          <msd-attachment-button
            *ngIf="mode === 'dietitian'"
            (click)="audioRecordingService.recording ? stopAudioRecord() : recordAudio()"
            [class.disabled]="isContentNotEmpty"
            [class.red-icon]="audioRecordingService.recording"
            [icon]="audioRecordingService.recording ? 'stop-fill' : 'mic'"
            [text]="audioRecordingService.recording ? audioRecordingService.remainingTime : undefined"
            placement="top"
            tooltip="Tous les vocaux sont accessibles pendant 10 jours. Ils sont ensuite automatiquement supprimés.">
          </msd-attachment-button>
          <msd-attachment-button
            (click)="imageInput.click()"
            [class.disabled]="isContentNotEmpty"
            [icon]="'image'"
            placement="top"
            tooltip="Toutes les images sont accessibles pendant 10 jours. Elles sont ensuite automatiquement supprimées.">
          </msd-attachment-button>
          <input #imageInput hidden type="file" accept="image/*" (change)="pictureSelected($event)">
        </div>
        <button id="send-button" class="btn btn-primary btn-gradient" (click)="send()"
          [disabled]="!isContentNotEmpty || sending" type="button">
          <ng-container *ngIf="sending; else validateButton">
            <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
            <span class="visually-hidden">Chargement...</span>
          </ng-container>
          <ng-template #validateButton>
            Envoyer
          </ng-template>
        </button>
      </div>
    </div>
  </div>
</div>

<ng-template #innerLoading>
  <ngx-inner-loading class="flex-center" [empty]="messages?.length === 0" [loading]="loading"
    (retry)="loadConversation()" [loadingDescription]="'Chargement...'" [emptyDescription]="'Aucun message ...'"
    [errorDescription]="'Une erreur est survenue, veuillez réessayer plus tard.'" [retryButtonText]="'Réessayer'">
  </ngx-inner-loading>
</ng-template>
